import { formatPhoneNumberIncomplete } from 'shared/lib/phoneNumber'
import { isNumeric } from 'shared/lib/isNumeric'

export const getLabelAsNumberInternationalFormat = (label: string) => {
  const isFirstPlus = label.startsWith('+')

  return isFirstPlus && isNumeric(label) ? formatPhoneNumberIncomplete(label) : label
}
